// src/store/reducers/userReducer.js
import { SET_SELECTED_USER } from "../Actions/shiftActions";

const initialState = {
  selectedUserID: "",
};

const ShiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_USER:
      return {
        selectedUserID: action.payload,
      };
    default:
      return state;
  }
};

export default ShiftReducer;
